import { zSysDataHistory } from "src/business/sysData/ZSysData";
import { maxNameLength } from "src/common/rxName";
import { zMdmFile } from "src/types/ZMdmFile";
import z from "zod";

export const zExtensionType = z.enum([
  "BUSINESS_RULE",
  "NESTED_FUNCTION",
  "CUSTOMIZATION",
]);
export type ZExtensionType = z.infer<typeof zExtensionType>;

export const extensionTypeLabels: Record<ZExtensionType, string> = {
  BUSINESS_RULE: "Бизнес-правило",
  NESTED_FUNCTION: "Вложенная функция",
  CUSTOMIZATION: "Кастомизация",
};

export const zExtensionScope = z.enum([
  "CATALOG",
  "CLASSIFIER",
  "SPECIFICATION_ATTRIBUTE",
  "WORKFLOW_STEP",
]);
export type ZExtensionScope = z.infer<typeof zExtensionScope>;

export const extensionScopeLabels: Record<ZExtensionScope, string> = {
  CATALOG: "Каталог",
  CLASSIFIER: "Классификатор",
  SPECIFICATION_ATTRIBUTE: "Атрибут спецификации",
  WORKFLOW_STEP: "Шаг рабочего потока",
};

export const zExtensionCommon = z.object({
  name: z.string().max(maxNameLength),
  description: z.string().nullish(),
  type: zExtensionType,
  file: zMdmFile.nullish(),
  version: z.string().max(maxNameLength).nullish(),
  scope: zExtensionScope.nullish(),
});
export type ZExtensionCommon = z.infer<typeof zExtensionCommon>;

export const zExtension = z.object({
  id: z.string(),
  displayId: z.number(),
  ...zExtensionCommon.shape,
  ...zSysDataHistory.shape,
});
export type ZExtension = z.infer<typeof zExtension>;

export type ExtensionsFilter = {};
